export const validation = {
  DEFAULT_ERROR_MESSAGE: 'Ocurrió un error. Por favor, intenta más tarde.',
  DEFAULT_ERROR: 'undefined error',

  WRONG_AUTH: 'La contraseña o el usuario son incorrectos.'
}

export const status = {
  DEFAULT_FETCHING_ERROR: 'error',
  STATUS_FETCHING: 'fetching',

  STATUS_LOGGED_VALIDATION: 'checking',

  STATUS_LOGING: 'logging',
  STATUS_LOGING_ERROR: 'error-logging',

  STATUS_GET_APPS: 'getting-apps',
  STATUS_GET_APPS_ERROR: 'error-getting-apps',
}